import { ConditionViolationType } from '@/warranty/domain/entities/condition-violation-status';
import type { PenaltyTimeseriesData } from '@/warranty/domain/entities/penalty-timeseries';
import { IWarrantyRepository } from '@/warranty/domain/repositories/warranty.repository';

export const dummyPenaltyTimelineData: IWarrantyRepository.GetPenaltyDetailsOutput =
  [
    // Country_Corner
    {
      id: 'PEN1-1',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B01',
      unitFullId: 'Country_Corner/B01/Rack_01',
      fullFrontendId: 'Country_Corner/B01/Rack_01',
      description: ConditionViolationType.HIGH_AVG_SOC,
      extremeValue: 87,
      unit: '%',
      timestamp: new Date('2024-03-01'),
      duration: 3,
      sohPenalty: 2,
    },
    {
      id: 'PEN1-2',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B01',
      unitFullId: 'Country_Corner/B01/Rack_01',
      fullFrontendId: 'Country_Corner/B01/Rack_01',
      description: ConditionViolationType.HIGH_AVG_SOC,
      extremeValue: 89,
      unit: '%',
      timestamp: new Date('2024-03-05'),
      duration: 4,
      sohPenalty: 2,
    },
    {
      id: 'PEN2-1',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B01',
      unitFullId: 'Country_Corner/B01/Rack_02',
      fullFrontendId: 'Country_Corner/B01/Rack_02',
      description: ConditionViolationType.LARGE_DOD,
      extremeValue: 91,
      unit: '%',
      timestamp: new Date('2024-03-03'),
      duration: 5,
      sohPenalty: 3,
    },
    {
      id: 'PEN3-1',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B01',
      unitFullId: 'Country_Corner/B01/Rack_03',
      fullFrontendId: 'Country_Corner/B01/Rack_03',
      description: ConditionViolationType.TEMPERATURE_SPIKE,
      extremeValue: 38,
      unit: '°C',
      timestamp: new Date('2024-03-06'),
      duration: 2,
      sohPenalty: 1,
    },
    {
      id: 'PEN5-1',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B01',
      unitFullId: 'Country_Corner/B01/Rack_05',
      fullFrontendId: 'Country_Corner/B01/Rack_05',
      description: ConditionViolationType.EXCESSIVE_CYCLING,
      extremeValue: 1600,
      unit: '',
      timestamp: new Date('2024-03-08'),
      duration: 6,
      sohPenalty: 4,
    },
    {
      id: 'PEN6-1',
      groupFullId: 'Country_Corner',
      topFullId: 'Country_Corner/B01',
      unitFullId: 'Country_Corner/B01/Rack_06',
      fullFrontendId: 'Country_Corner/B01/Rack_06',
      description: ConditionViolationType.HIGH_AVG_SOC,
      extremeValue: NaN,
      unit: '%',
      timestamp: new Date('2024-03-10'),
      duration: 1,
      sohPenalty: 1,
    },

    // Sunset_Plaza
    {
      id: 'PEN7-1',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B01',
      unitFullId: 'Sunset_Plaza/B01/Rack_01',
      fullFrontendId: 'Sunset_Plaza/B01/Rack_01',
      description: ConditionViolationType.HIGH_AVG_SOC,
      extremeValue: 85,
      unit: '%',
      timestamp: new Date('2024-03-01'),
      duration: 2,
      sohPenalty: 2,
    },
    {
      id: 'PEN8-1',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B01',
      unitFullId: 'Sunset_Plaza/B01/Rack_02',
      fullFrontendId: 'Sunset_Plaza/B01/Rack_02',
      description: ConditionViolationType.LARGE_DOD,
      extremeValue: 94,
      unit: '%',
      timestamp: new Date('2024-03-03'),
      duration: 6,
      sohPenalty: 3,
    },
    {
      id: 'PEN9-1',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B01',
      unitFullId: 'Sunset_Plaza/B01/Rack_03',
      fullFrontendId: 'Sunset_Plaza/B01/Rack_03',
      description: ConditionViolationType.TEMPERATURE_SPIKE,
      extremeValue: 37.5,
      unit: '°C',
      timestamp: new Date('2024-03-04'),
      duration: 3,
      sohPenalty: 2,
    },
    {
      id: 'PEN11-1',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B01',
      unitFullId: 'Sunset_Plaza/B01/Rack_05',
      fullFrontendId: 'Sunset_Plaza/B01/Rack_05',
      description: ConditionViolationType.EXCESSIVE_CYCLING,
      extremeValue: 1550,
      unit: '',
      timestamp: new Date('2024-03-09'),
      duration: 5,
      sohPenalty: 4,
    },
    {
      id: 'PEN12-1',
      groupFullId: 'Sunset_Plaza',
      topFullId: 'Sunset_Plaza/B01',
      unitFullId: 'Sunset_Plaza/B01/Rack_06',
      fullFrontendId: 'Sunset_Plaza/B01/Rack_06',
      description: ConditionViolationType.TEMPERATURE_SPIKE,
      extremeValue: NaN,
      unit: '°C',
      timestamp: new Date('2024-03-10'),
      duration: 2,
      sohPenalty: 1,
    },

    // Smart_Hill
    {
      id: 'PEN13-1',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B01',
      unitFullId: 'Smart_Hill/B01/Rack_01',
      fullFrontendId: 'Smart_Hill/B01/Rack_01',
      description: ConditionViolationType.HIGH_AVG_SOC,
      extremeValue: 90,
      unit: '%',
      timestamp: new Date('2024-03-02'),
      duration: 4,
      sohPenalty: 2,
    },
    {
      id: 'PEN14-1',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B01',
      unitFullId: 'Smart_Hill/B01/Rack_02',
      fullFrontendId: 'Smart_Hill/B01/Rack_02',
      description: ConditionViolationType.LARGE_DOD,
      extremeValue: 92,
      unit: '%',
      timestamp: new Date('2024-03-04'),
      duration: 4,
      sohPenalty: 3,
    },
    {
      id: 'PEN15-1',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B01',
      unitFullId: 'Smart_Hill/B01/Rack_03',
      fullFrontendId: 'Smart_Hill/B01/Rack_03',
      description: ConditionViolationType.TEMPERATURE_SPIKE,
      extremeValue: 36.8,
      unit: '°C',
      timestamp: new Date('2024-03-05'),
      duration: 3,
      sohPenalty: 2,
    },
    {
      id: 'PEN17-1',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B01',
      unitFullId: 'Smart_Hill/B01/Rack_05',
      fullFrontendId: 'Smart_Hill/B01/Rack_05',
      description: ConditionViolationType.EXCESSIVE_CYCLING,
      extremeValue: 1380,
      unit: '',
      timestamp: new Date('2024-03-08'),
      duration: 4,
      sohPenalty: 4,
    },
    {
      id: 'PEN18-1',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B01',
      unitFullId: 'Smart_Hill/B01/Rack_06',
      fullFrontendId: 'Smart_Hill/B01/Rack_06',
      description: ConditionViolationType.HIGH_AVG_SOC,
      extremeValue: NaN,
      unit: '%',
      timestamp: new Date('2024-03-11'),
      duration: 2,
      sohPenalty: 1,
    },
    {
      id: 'PEN19-1',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B01',
      unitFullId: 'Smart_Hill/B01/Rack_07',
      fullFrontendId: 'Smart_Hill/B01/Rack_07',
      description: ConditionViolationType.REST_SOC,
      extremeValue: 82,
      unit: '%',
      timestamp: new Date('2024-03-12'),
      duration: 3,
      sohPenalty: 2,
    },
    {
      id: 'PEN20-1',
      groupFullId: 'Smart_Hill',
      topFullId: 'Smart_Hill/B01',
      unitFullId: 'Smart_Hill/B01/Rack_08',
      fullFrontendId: 'Smart_Hill/B01/Rack_08',
      description: ConditionViolationType.THROUGHPUT,
      extremeValue: 12000,
      unit: 'Wh',
      timestamp: new Date('2024-03-13'),
      duration: 4,
      sohPenalty: 3,
    },
  ];

export const dummyPenaltyTimeseriesData: PenaltyTimeseriesData[] = [
  // Country_Corner
  {
    id: 'TS1',
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B01',
    unitFullId: 'Country_Corner/B01/Rack_01',
    fullFrontendId: 'Country_Corner/B01/Rack_01',
    description: ConditionViolationType.HIGH_AVG_SOC,
    timeseries: [
      { timestamp: new Date('2024-03-01'), count: 1 },
      { timestamp: new Date('2024-03-04'), count: 2 },
    ],
  },
  {
    id: 'TS2',
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B01',
    unitFullId: 'Country_Corner/B01/Rack_02',
    fullFrontendId: 'Country_Corner/B01/Rack_02',
    description: ConditionViolationType.LARGE_DOD,
    timeseries: [
      { timestamp: new Date('2024-03-03'), count: 1 },
      { timestamp: new Date('2024-03-07'), count: 1 },
    ],
  },
  {
    id: 'TS3',
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B01',
    unitFullId: 'Country_Corner/B01/Rack_03',
    fullFrontendId: 'Country_Corner/B01/Rack_03',
    description: ConditionViolationType.TEMPERATURE_SPIKE,
    timeseries: [
      { timestamp: new Date('2024-03-02'), count: 1 },
      { timestamp: new Date('2024-03-05'), count: 1 },
    ],
  },
  {
    id: 'TS5',
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B01',
    unitFullId: 'Country_Corner/B01/Rack_05',
    fullFrontendId: 'Country_Corner/B01/Rack_05',
    description: ConditionViolationType.EXCESSIVE_CYCLING,
    timeseries: [{ timestamp: new Date('2024-03-08'), count: 1 }],
  },
  {
    id: 'TS6',
    groupFullId: 'Country_Corner',
    topFullId: 'Country_Corner/B01',
    unitFullId: 'Country_Corner/B01/Rack_06',
    fullFrontendId: 'Country_Corner/B01/Rack_06',
    description: ConditionViolationType.TEMPERATURE_SPIKE,
    timeseries: [{ timestamp: new Date('2024-03-10'), count: 1 }],
  },

  // Sunset_Plaza
  {
    id: 'TS7',
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B01',
    unitFullId: 'Sunset_Plaza/B01/Rack_01',
    fullFrontendId: 'Sunset_Plaza/B01/Rack_01',
    description: ConditionViolationType.HIGH_AVG_SOC,
    timeseries: [
      { timestamp: new Date('2024-03-01'), count: 1 },
      { timestamp: new Date('2024-03-03'), count: 1 },
    ],
  },
  {
    id: 'TS8',
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B01',
    unitFullId: 'Sunset_Plaza/B01/Rack_02',
    fullFrontendId: 'Sunset_Plaza/B01/Rack_02',
    description: ConditionViolationType.LARGE_DOD,
    timeseries: [{ timestamp: new Date('2024-03-04'), count: 2 }],
  },
  {
    id: 'TS9',
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B01',
    unitFullId: 'Sunset_Plaza/B01/Rack_03',
    fullFrontendId: 'Sunset_Plaza/B01/Rack_03',
    description: ConditionViolationType.TEMPERATURE_SPIKE,
    timeseries: [{ timestamp: new Date('2024-03-06'), count: 1 }],
  },
  {
    id: 'TS11',
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B01',
    unitFullId: 'Sunset_Plaza/B01/Rack_05',
    fullFrontendId: 'Sunset_Plaza/B01/Rack_05',
    description: ConditionViolationType.EXCESSIVE_CYCLING,
    timeseries: [{ timestamp: new Date('2024-03-08'), count: 2 }],
  },
  {
    id: 'TS12',
    groupFullId: 'Sunset_Plaza',
    topFullId: 'Sunset_Plaza/B01',
    unitFullId: 'Sunset_Plaza/B01/Rack_06',
    fullFrontendId: 'Sunset_Plaza/B01/Rack_06',
    description: ConditionViolationType.TEMPERATURE_SPIKE,
    timeseries: [{ timestamp: new Date('2024-03-10'), count: 1 }],
  },

  // Smart_Hill
  {
    id: 'TS13',
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B01',
    unitFullId: 'Smart_Hill/B01/Rack_01',
    fullFrontendId: 'Smart_Hill/B01/Rack_01',
    description: ConditionViolationType.HIGH_AVG_SOC,
    timeseries: [
      { timestamp: new Date('2024-03-01'), count: 1 },
      { timestamp: new Date('2024-03-05'), count: 1 },
    ],
  },
  {
    id: 'TS14',
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B01',
    unitFullId: 'Smart_Hill/B01/Rack_02',
    fullFrontendId: 'Smart_Hill/B01/Rack_02',
    description: ConditionViolationType.LARGE_DOD,
    timeseries: [
      { timestamp: new Date('2024-03-03'), count: 1 },
      { timestamp: new Date('2024-03-04'), count: 1 },
    ],
  },
  {
    id: 'TS15',
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B01',
    unitFullId: 'Smart_Hill/B01/Rack_03',
    fullFrontendId: 'Smart_Hill/B01/Rack_03',
    description: ConditionViolationType.TEMPERATURE_SPIKE,
    timeseries: [{ timestamp: new Date('2024-03-06'), count: 1 }],
  },
  {
    id: 'TS17',
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B01',
    unitFullId: 'Smart_Hill/B01/Rack_05',
    fullFrontendId: 'Smart_Hill/B01/Rack_05',
    description: ConditionViolationType.EXCESSIVE_CYCLING,
    timeseries: [
      { timestamp: new Date('2024-03-08'), count: 1 },
      { timestamp: new Date('2024-03-09'), count: 1 },
    ],
  },
  {
    id: 'TS18',
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B01',
    unitFullId: 'Smart_Hill/B01/Rack_06',
    fullFrontendId: 'Smart_Hill/B01/Rack_06',
    description: ConditionViolationType.TEMPERATURE_SPIKE,
    timeseries: [{ timestamp: new Date('2024-03-10'), count: 2 }],
  },
  {
    id: 'TS19',
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B01',
    unitFullId: 'Smart_Hill/B01/Rack_07',
    fullFrontendId: 'Smart_Hill/B01/Rack_07',
    description: ConditionViolationType.REST_SOC,
    timeseries: [
      { timestamp: new Date('2024-03-12'), count: 1 },
      { timestamp: new Date('2024-03-13'), count: 1 },
    ],
  },
  {
    id: 'TS20',
    groupFullId: 'Smart_Hill',
    topFullId: 'Smart_Hill/B01',
    unitFullId: 'Smart_Hill/B01/Rack_08',
    fullFrontendId: 'Smart_Hill/B01/Rack_08',
    description: ConditionViolationType.THROUGHPUT,
    timeseries: [{ timestamp: new Date('2024-03-13'), count: 2 }],
  },
];
